import React, { useState, useEffect } from 'react';
import Layout from '../layouts/Layout';
import { FaMoneyBillWave, FaCalendar, FaClipboardList, FaCheck, FaTimes, FaSpinner, FaDollarSign } from 'react-icons/fa';
import axios from 'axios';
import './LoanHistory.css';

const LoanHistory = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseUrl = "https://api.burrayhr.com";

  useEffect(() => {
    fetchLoans();
  }, []);

  const fetchLoans = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${baseUrl}/api/loans/`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setLoans(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching loans:', error);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'status-approved';
      case 'rejected':
        return 'status-rejected';
      case 'pending':
        return 'status-pending';
      default:
        return '';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <Layout>
      <div className="loan-history-container">
        <div className="loan-history-header">
          <FaMoneyBillWave style={{color: 'navy'}} className="" />
          <h2>Loan History</h2>
        </div>

        {loading ? (
          <div className="loading-state">
            <FaSpinner className="spinner" />
            <p>Loading loan history...</p>
          </div>
        ) : loans.length === 0 ? (
          <div className="no-loans">
            <FaClipboardList className="no-loans-icon" />
            <p>No loan history found</p>
          </div>
        ) : (
          <div className="loan-cards-grid">
            {loans.map((loan) => (
              <div key={loan.id} className="loan-card">
                <div className="loan-card-header">
                  <h3>{loan.type}</h3>
                  <span className={`status-badge ${getStatusColor(loan.status)}`}>
                    {loan.status === 'pending' && <FaSpinner className="status-icon spinning" />}
                    {loan.status === 'approved' && <FaCheck className="status-icon" />}
                    {loan.status === 'rejected' && <FaTimes className="status-icon" />}
                    {loan.status}
                  </span>
                </div>

                <div className="loan-details">
                  <div className="detail-row">
                    <FaMoneyBillWave className="detail-icon" />
                    <div className="detail-content">
                      <span className="detail-label">Amount</span>
                      <span className="detail-value">${loan.amount}</span>
                    </div>
                  </div>

                  <div className="detail-row">
                    <FaCalendar className="detail-icon" />
                    <div className="detail-content">
                      <span className="detail-label">Repayment Period</span>
                      <span className="detail-value">{loan.repayment_period} days</span>
                    </div>
                  </div>

                  <div className="detail-row">
                    <FaClipboardList className="detail-icon" />
                    <div className="detail-content">
                      <span className="detail-label">Reason</span>
                      <p className="detail-value reason-text">{loan.reason}</p>
                    </div>
                  </div>

                  {loan.response_message && (
                    <div className="detail-row">
                      <FaClipboardList className="detail-icon" />
                      <div className="detail-content">
                        <span className="detail-label">Response</span>
                        <p className="detail-value response-text">{loan.response_message}</p>
                      </div>
                    </div>
                  )}
                </div>

                <div className="loan-card-footer">
                  <span className="submission-date">
                    Submitted on {formatDate(loan.created_at)}
                  </span>
                  {loan.is_paid && (
                    <span className="paid-badge">
                      <FaDollarSign className="paid-icon" />
                      Paid
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default LoanHistory;
